import { render, staticRenderFns } from "./PageCustomDashboard.vue?vue&type=template&id=24670c79&scoped=true"
import script from "./PageCustomDashboard.vue?vue&type=script&lang=js"
export * from "./PageCustomDashboard.vue?vue&type=script&lang=js"
import style0 from "./PageCustomDashboard.vue?vue&type=style&index=0&id=24670c79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24670c79",
  null
  
)

export default component.exports